﻿import $ from 'jquery'

declare global {
  interface JQuery {
    toggleShow(condition: boolean): JQuery;
  }
}

(function ($) {
  $.fn.toggleShow = function (condition) {
    return $(this).each(function () {
      ToggleShow.execute(this, condition);
    });
  }
})($);

interface IToggleShowElement extends HTMLElement{
  originalDisplayValue: string;
}

export class ToggleShow {

  public static execute(element: HTMLElement, condition: boolean): void {
    if (condition)
      this.show(element as IToggleShowElement);
    else
      this.hide(element as IToggleShowElement);
  }

  private static show(element: IToggleShowElement): void {
    if (element.style.display === 'none') {
      element.style.display = element.originalDisplayValue || '';
      element.originalDisplayValue = undefined;
    }
  }

  private static hide(element: IToggleShowElement): void {
    if (element.style.display !== 'none') {
      element.originalDisplayValue = element.style.display;
      element.style.display = 'none';
    }
  }
}

export default ToggleShow;